import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Navigate, useParams, useLocation, useSearchParams } from "react-router-dom";
import dayjs from "dayjs";
import { useAssetTags, useCheckpointData, useCheckpoints, useTags, useTagsForScan, useTemplateDetail, useUserDetail, useUserPermissions, useUserTableHeader } from "../../services/hooks";
import "./Checkpoint.css";
import DynamicFormRender from "../Dynamic/DynamicForm";
import { Button, DetailCard, Dialog, Drawer, Dropdown, GenericTable, Loader, TableColumnCustomizer, generateDetailRows, tCell, toastMessage } from "../utils/index";
import theme, { buttonClasses, textClasses } from "../utils/theme";
import { useSaveCheckoutFormMutation, useSaveCheckpointFormMutation, useLazyGetCheckpointEntryDetailQuery, useUpdateUserTableHeadersMutation } from "../../api/vmsSlice";
import {Card, Grid, Paper, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs } from "@mui/material";
import { capitalizeCamelCase, capitalizeSentence, findDeepValue, flattenObj, formatDate, isFilePath, parseUnderscore, removeSpecialChars } from "../../services/functions";
import { CameraEntryIcon, CloseIcon, EyeIcon, FilterListIcon, ManualEntryIcon, QrCodeIcon, SettingsInputAntennaIcon } from "../../services/icons";
import Genericfilter from "../utils/Genericfilter";
import Genericstats from "../utils/Genericstats";
import { debounce } from "../../services/functions";
import { useAddAssetTagMutation, useUpdateAssetTagMutation } from "../../api/deviceSlice";
import PrintLabel from "./PrintLabel";
import { checkForFlags } from "../Dynamic/helper";
import { useSocketContext } from "../../context/socketContext";
import FilePreview from "../utils/FilePreview";
import CommonTour, { TourIcon } from "../Tour/CommonTour";
import CustomizeTripWorkflow from "./CustomizeTripWorkflow";
import { usePlantContext } from "../../context/plantContext";
// import DynamicFormIFrame from "../Dynamic/DynamicFormIframe";
import VehicleJourneyDetailCard, { VehicleJourneyDetailSkeleton } from "./GenerateDetail";

const REDIRECTION_URL = "/not-authorized";
const CheckpointTour = [
	{
		target: ".checkpoint_heading",
		content: "This is your Checkpoint Management dashboard. Here you can monitor and manage all checkpoint activities.",
		placement: "bottom",
	},
	{
		target: ".checkpoint_panel button", // Target the "Add New" button
		content: "Click here to create a new checkpoint entry.",
		placement: "left",
	},
	{
		target: ".genericStats-containter",
		content: "These statistics cards show key metrics about checkpoint activities.",
		placement: "bottom",
	},
	// {
	//   target: '.checkpoint_tabs',
	//   content: 'Switch between different views of checkpoint data using these tabs.',
	//   placement: 'bottom'
	// },
	{
		target: "#Genericfilter",
		content: "Filter checkpoint entries by vehicle number, trip ID, date range, or status.",
		placement: "bottom",
	},
	{
		target: ".main_content",
		content: "This table lists all checkpoint entries with their details. Click the eye icon to view more information.",
		placement: "top",
	},
	{
		target: ".eyeIcon", // Target the eye icon
		content: "Click this icon to view detailed information about a checkpoint entry.",
		placement: "left",
		// action: async () => {
		// 	const firstViewIcon = document.querySelector(".eyeIcon");
		// 	if (firstViewIcon) {
		// 		firstViewIcon.click();
		// 		await waitForElement("#cpdetails", 2000);
		// 	}
		// },
	},
	// {
	// 	target: "#cpdetails",
	// 	content: "This panel shows comprehensive details about the selected checkpoint entry, including timestamps and form data.",
	// 	placement: "left",
	// },
];
// function waitForElement(selector, timeout = 1000) {
// 	return new Promise((resolve, reject) => {
// 		const start = Date.now();
// 		const check = () => {
// 			const el = document.querySelector(selector);
// 			if (el) {
// 				resolve(el);
// 			} else if (Date.now() - start >= timeout) {
// 				reject(new Error(`Element ${selector} not found within ${timeout}ms`));
// 			} else {
// 				setTimeout(check, 100);
// 			}
// 		};
// 		check();
// 	});
// }
const dummyTourData = [
	{
		_id: "6819976ec76710aa643a141f",
		approvalStatus: "Approved",
		created_by: {
			email: "ashishtest@gmail.com",
			name: "ashishAdmin",
			user_id: "65fbd96d6bc11b2703fac28d",
			user_type: "admin",
		},
		created_on: "2025-05-06T05:00:30.874Z",
		current_checkpoint_no: 1,
		data: [
			{
				checkpointId: "660a84dd01071b25bd87c195",
				checkpointNumber: 1,
				created_on: "2025-05-06T05:00:30.901Z",
				vehicleEntryId: "6819976ec76710aa643a141f",
				vehicleId: "67a0b563ff47a31b42b26950",
				formData: {
					driverName: "John Doe",
					driverNumber: "9000000000",
					file: "",
					location: "Delhi",
					product: [
						{
							productName: "Meals on Wheels",
							_id: "66e42ebc0a31dc2cbfb672a3",
							priority: 1,
							workFlowId: "66ed3a8452abaf750816da1b",
						},
					],
					productCategory: {
						productCategory: "Organic Matter",
						_id: "66277b5b14e79a6f9feb2e86",
					},
					reg_no: "DL06A2025",
					remark: "",
					rfidTag: "",
					supplier: {
						supplierId: "0001",
						supplierName: "Los Pollos Hermanos",
						_id: "660a973d01071b25bd87c8f2",
					},
					vehicleId: "67a0b563ff47a31b42b26950",
					vehicleNumber: "XX00XX0000",
				},
				formDataHistory: [],
				orgId: "65fbd1a953312156626a627d",
				type: "in",
				__v: 0,
				_id: "6819976ec76710aa643a1418",
			},
		],
		driverName: "John Doe",
		driverNumber: "9000000000",
		vehicleId: "67a0b563ff47a31b42b26950",
		fallbackWorkflowId: "66ed3a8452abaf750816da1b",
		formData: {
			driverName: "John Doe",
			driverNumber: "900000000",
			file: "",
			location: "Delhi",
		},
		product: [
			{
				priority: 1,
				productName: "Meals on Wheels",
				workFlowId: "66ed3a8452abaf750816da1b",
				_id: "66e42ebc0a31dc2cbfb672a3",
				productCategory: {
					productCategory: "Organic Matter",
					_id: "66277b5b14e79a6f9feb2e86",
				},
			},
		],
		reg_no: "XX00XX0000",
		remark: "",
		rfidTag: "",
		supplier: {
			supplierId: "0001",
			supplierName: "Los Pollos Hermanos",
			_id: "660a973d01071b25bd87c8f2",
		},
		// vehicleId: "67a0b563ff47a31b42b26950",
		vehicleNumber: "XX00XX0000",
		inTime: "2025-05-06T05:00:30.673Z",
		isApproved: true,
		location: {
			latitude: -90,
			longitude: -90,
		},
		modified_on: "2025-05-06T05:00:30.874Z",
		orgId: "65fbd1a953312156626a627d",
		outTime: "2025-05-06T05:00:30.711Z",
		product_ids: ["66e42ebc0a31dc2cbfb672a3"],
		status: "accessManagement",
		statusHistory: [
			{
				_id: "6819976ec76710aa643a1418",
				checkInDataID: "6819976ec76710aa643a1418",
				userDetails: {
					userId: "65fbd96d6bc11b2703fac28d",
					userType: "admin",
				},
				type: "manual",
				checkpointId: "660a84dd01071b25bd87c195",
				checkpointNumber: 1,
				checkpointType: "access",
				displayName: "access management",
				inTime: "2025-05-06T05:00:30.874Z",
				outTime: "2025-05-06T05:00:30.874Z",
			},
		],
		templateId: "667d30e8013d34503aea1715",
		trip_counter: "AM00-00XXXxxXX000",
		trip_over: false,
		trip_status: "Ongoing",
		__v: 0,
	},
];

export function generateDetail(data, tableHeader, handlePrint, historicalDataHeaderMap = {}, customizeTripWorkflow = false, handleCustomizeTripWokflow, inTimeOutTimeConfig, printLabelPerm) {
	if (!data) return [];
	let history = [...data.statusHistory];
	let newStaticDetail;
	// console.log(" ================== DATA ================== \n ", data)
	// checkInDataID added during create vehicle entry
	// checkOutDataID added during checkout vehicle
	// else case is for old data
	if (history.some((event) => event.hasOwnProperty("checkInDataID") || event.hasOwnProperty("checkOutDataID"))) {
		let eventData = [...data?.data];
		let index = 0;
		newStaticDetail = [];
		while (history.length) {
			let currentEvent = history.shift();
			let { displayName, outTime, inTime, checkpointType, checkpointId, _basis } = currentEvent;
			let isOfflinePacket = _basis == "offline-packet";
			let { hideInTime = false, hideOutTime = false, inTimeLabel = "In Time", outTimeLabel = "Out Time" } = inTimeOutTimeConfig[checkpointId] || {};

			let blocks = [];
			if (!hideInTime) {
				//checkpointType == "access" ? "Approval Request Time" : checkpointType == "bay" ? "Dock Operation Start" : "In Time"
				blocks.push(
					<div className="detail_row" key={inTime + displayName}>
						<div className="detail_row_title">{inTimeLabel}</div>
						<div className="detail_row_value">{formatDate(inTime)}</div>
					</div>
				);
			}
			if (!hideOutTime) {
				//checkpointType == "access" ? "Approval Accepted Time" : checkpointType == "bay" ? "Dock Operation End" : "Out Time"
				blocks.push(
					<div className="detail_row" key={outTime + index + displayName}>
						<div className="detail_row_title">{outTimeLabel}</div>
						<div className="detail_row_value">{formatDate(outTime)}</div>
					</div>
				);
			}
			while (eventData.length && (eventData.type == "In / Out" || eventData[0]._id == currentEvent?.checkInDataID || eventData[0]._id == currentEvent?.checkOutDataID)) {
				let currentData = eventData.shift();
				if (currentData.type == "In / Out") {
					continue;
				}
				let type = currentData.type;

				let rows = [];
				const currentTableHeader = historicalDataHeaderMap[`${currentData.checkpointId}-${type}`];
				// console.log('currentTableHeader', currentTableHeader)
				if (currentTableHeader) {
					currentTableHeader.forEach((header) => {
						let value = findDeepValue(currentData, header.name?.split("."));
						if (value == "-") {
							value = findDeepValue(currentData.formData, header.name?.split("."));
						}
						if (Array.isArray(value)) {
							value = new Array(...value);
						} else {
							value = String(value);
						}
						if (value && value != "-") {
							const isoPattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?(Z|[+-]\d{2}:\d{2})?$/;
							if (new Date(value) != "Invalid Date" && isoPattern.test(value)) {
								value = formatDate(value);
							}
							rows.push(
								<div className="detail_row" key={header.label}>
									<div className="detail_row_title">{header.label}</div>
									<div className="detail_row_value">
										{Array.isArray(value) ? (
											<span style={{ display: "flex", flexWrap: "wrap", gap: "5px" }}>
												{value.map((el, i) => (isFilePath(el) ? <FilePreview key={i} fileKey={el} extension={String(el).split(".").pop()} /> : capitalizeCamelCase(el)))}
											</span>
										) : isFilePath(value) ? (
											<FilePreview fileKey={value} extension={value.split(".").pop()} />
										) : (
											capitalizeCamelCase(value)
										)}
									</div>
								</div>
							);
						}
					});
				} else {
					let processedData = {};
					flattenObj(processedData, currentData.formData);
					delete processedData.vehicleId;
					delete processedData.vehicleId;
					for (let key in processedData) {
						let value = processedData[key];
						if (Array.isArray(value)) {
							value = new Array(...value);
						} else {
							value = String(value);
						}
						if (value && value != "-") {
							const isoPattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?(Z|[+-]\d{2}:\d{2})?$/;
							if (new Date(value) != "Invalid Date" && isoPattern.test(value)) {
								value = formatDate(value);
							}
							rows.push(
								<div className="detail_row" key={key}>
									<div className="detail_row_title">{capitalizeSentence(capitalizeCamelCase(parseUnderscore(key)))}</div>
									<div className="detail_row_value">
										{Array.isArray(value) ? (
											<span style={{ display: "flex", flexWrap: "wrap", gap: "5px" }}>
												{value.map((el, i) => (isFilePath(el) ? <FilePreview key={i} fileKey={el} extension={String(el).split(".").pop()} /> : capitalizeCamelCase(el)))}
											</span>
										) : isFilePath(value) ? (
											<FilePreview fileKey={value} extension={value.split(".").pop()} />
										) : (
											capitalizeCamelCase(value)
										)}
									</div>
								</div>
							);
						}
					}
				}

				let block = (
					<div className="statusHistory-detail-content" style={{ margin: "0", minHeight: "50px" }}>
						<div style={{ fontSize: "0.9rem", fontWeight: "bold", textAlign: "center", color: "var(--text-color)" }}>{capitalizeSentence(type)}</div>
						<div style={{ padding: "0", borderRadius: "12px", color: "var(--text-color)" }}>{rows}</div>
					</div>
				);
				if (rows?.length) {
					blocks.push(block);
				}
			}
			let view = (
				<div key={index++} className="statusHistory-detail-content" style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
					<div style={{ fontWeight: "bold", textAlign: "center", color: "var(--text-color)", position: "relative" }}>
						{displayName}
						{isOfflinePacket ? <span className="offline-packet" style={{fontSize: "0.6rem"}}>Offline</span> : null}
					</div>

					{blocks}
				</div>
			);
			newStaticDetail.push(view);
		}
	} else {
		newStaticDetail = data.statusHistory?.map(({ displayName, inTime, outTime, checkpointId, checkpointType, _id }, i) => {
			let type;
			let res = data?.data?.map((_, i) => {
				let result = {};
				if (_._id === _id) {
					//previous cond==> _.checkpointId === checkpointId
					flattenObj(result, _.formData);
					type = _.type;
					delete result._id;
					delete result.vehicleId;
					delete result.vehicleId;
				}
				return result;
			});
			// console.log('detail res===>', res)
			let rows = [];
			for (let obj of res) {
				for (let key in obj) {
					if (obj[key]) {
						rows.push(
							<div className="detail_row" key={key}>
								<div className="detail_row_title">{capitalizeSentence(capitalizeCamelCase(parseUnderscore(key)))}</div>
								<div className="detail_row_value">{obj[key]}</div>
							</div>
						);
					}
				}
			}
			rows.push(
				<div className="detail_row" key={inTime + displayName}>
					<div className="detail_row_title">{checkpointType == "access" ? "Approval Request Time" : checkpointType == "bay" ? "Dock Operation Start" : "In Time"}</div>
					<div className="detail_row_value">{formatDate(inTime)}</div>
				</div>
			);
			rows.push(
				<div className="detail_row" key={outTime + i + displayName}>
					<div className="detail_row_title">{checkpointType == "access" ? "Approval Accepted Time" : checkpointType == "bay" ? "Dock Operation End" : "Out Time"}</div>
					<div className="detail_row_value">{formatDate(outTime)}</div>
				</div>
			);
			const view = (
				<div key={i} className="statusHistory-detail-content">
					<div style={{ fontWeight: "bold", textAlign: "center", color: "var(--text-color)" }}>{displayName}</div>
					<div style={{ padding: "0.5rem", borderRadius: "12px", color: "var(--text-color)" }}>{rows}</div>
				</div>
			);
			return view;
		});
	}
	// console.log("dete", data)
	const details = tableHeader.map((_) => ({ label: _.label, value: _.type == "date" ? formatDate(findDeepValue(data, _.name.split("."))) : findDeepValue(data, _.name.split(".")) }));
	return (
		<>
			{printLabelPerm || customizeTripWorkflow ? (
				<div style={{ display: "flex", flexDirection: "column", gap: "0.8rem", justifyContent: "end", alignItems: "center", marginBottom: "1rem" }}>
					{printLabelPerm ? (
						<Button onClick={handlePrint} style={{ ...buttonClasses.lynkitOrangeEmpty }}>
							<QrCodeIcon /> Print Label
						</Button>
					) : null}

					{customizeTripWorkflow && (
						<Button onClick={handleCustomizeTripWokflow} style={{ ...buttonClasses.lynkitOrangeEmpty }}>
							Customize Trip Workflow
						</Button>
					)}
				</div>
			) : null}

			{generateDetailRows(details)}
			{data.mapCount != undefined && data.scanCount != undefined ? (
				<div className="statusHistory-detail-content" style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
					<div style={{ fontWeight: "bold", textAlign: "center", color: "var(--text-color)" }}>Asset Details</div>
					<div className="detail_row">
						<div className="detail_row_title">Assets Mapped</div>
						<div className="detail_row_value">{data.mapCount}</div>
					</div>
					<div className="detail_row">
						<div className="detail_row_title">Assets Scanned</div>
						<div className="detail_row_value">{data.scanCount}</div>
					</div>
					<div className="detail_row">
						<div className="detail_row_title">Assets Remaining</div>
						<div className="detail_row_value">{data.mapCount - data.scanCount}</div>
					</div>
				</div>
			) : null}
			{newStaticDetail}
		</>
	);
}

const currCheckpointPerm = (currentCheckpoint, userPermissions) => {
	if (!currentCheckpoint) return true;
	if (!Object.keys(userPermissions).length) return true;
	const permission = {};
	Object.keys(userPermissions).forEach((ele, index) => {
		if (ele.includes(currentCheckpoint)) {
			const match = ele.match(/[^-]+$/);
			const result = match ? (match[0] == currentCheckpoint ? "currentPage" : match[0]) : "";
			permission[result] = userPermissions[ele];
		}
	});

	return permission;
};

export const dataIconMap = {
	Camera: <CameraEntryIcon />,
	Scan: <SettingsInputAntennaIcon />,
	Manual: <ManualEntryIcon />,
};

const today = dayjs();
const oneMonthBefore = today.subtract(1, "month");
const oneWeekBefore = today.subtract(1, "week");
const defaultStartDate = oneWeekBefore.toISOString();
const defaultEndDate = today.toISOString();

const defaultFilter = {
	pagesize: 10,
	page_no: 1,
	start: defaultStartDate,
	end: defaultEndDate,
};
/**
 * This component is used to render different data based on the Current Checkpoint
 */
const Checkpoint = () => {
	const { userPermissions, isFetched } = useUserPermissions();
	const location = useLocation();
	const { userDetail } = useUserDetail();
	const tourRef = useRef();
	const [isTourMode, setIsTourMode] = useState(false);
	const shouldRunTour = !userDetail?.moduleTour?.checkpoint;
	const { checkpoints, isLoading, isCheckpointFetched, checkoutConfigMap } = useCheckpoints();
	const [searchParams] = useSearchParams();
	const vehicleNumber = searchParams.get("vehicleNumber");
	const { plantId, plantName, setIsCheckpointForm } = usePlantContext();
	// grab checkpoint type and number from the url params
	const { type, number } = useParams();

	// real time data from socket; we merge it with the other data when rendering
	const {
		socketData: { checkpointEvents: _checkpointEvents },
	} = useSocketContext();
	let checkpointEvents = _checkpointEvents.filter((_) => _.current_checkpoint_no == number && _.plantId === plantId) || [];
	// check if the type and number from the params are valid
	const isInValidCheckpoint = !checkpoints.find((_) => _.checkpointType == type && _.checkpointNumber == number);

	// extract information of current checkpoint
	const currentCheckpoint = checkpoints.find((_) => (number ? _.checkpointType == type && _.checkpointNumber == number : _.checkpointType == type)) || {};
	const { displayName, _id: checkpointId, checkpointType, listingConfig, checkoutConfig = {}, checkpointNumber, detailApi, assetConfig = {}, sendApproval, templateId, customizeTripWorkflow } = currentCheckpoint;
	const { checkoutOnSubmit, buttonLabel: checkoutBtnLabel, api: checkoutFormEndpoint, checkoutOnApproval, entrySuccessText = "Submitted" } = checkoutConfig;
	const { assetAdd, assetScan } = assetConfig;
	// find all permissions for the current checkpoint
	const currentChkPermission = currCheckpointPerm(checkpointId, userPermissions);

	// a ref to keep track of filters
	const filterRef = useRef(defaultFilter);
	const { page_no, pagesize } = filterRef.current;

	const { trigger, checkpointData, isLoading: isCheckpointDataLoading, tableHeader, count } = useCheckpointData(filterRef.current);

	const { templateDetail, getTemplateDetail } = useTemplateDetail(null, "filterForm");
	const { userTableHeaders, getUserTableHeaders } = useUserTableHeader();
	const [updateTableHeader] = useUpdateUserTableHeadersMutation();
	useEffect(() => {
		if (templateId) {
			getTemplateDetail({ id: templateId, onlyFilterFields: true });
			getUserTableHeaders({ template_id: templateId });
		}
	}, [templateId]);

	const { primaryFilters, secondaryFilters } = useMemo(() => {
		const primaryFilters = [];
		const secondaryFilters = [];
		for (let attr of templateDetail?.attributes || []) {
			let _attr = { ...attr, required: false };
			if (attr.isPrimaryFilter) {
				primaryFilters.push(_attr);
			}
			secondaryFilters.push(_attr);
		}
		return { primaryFilters, secondaryFilters };
	}, [templateDetail]);
	// console.log({ primaryFilters, secondaryFilters });
	const [showFilters, setShowFilters] = useState(false);
	// sort the tabs based on order
	const tabs = [...(listingConfig || [])].sort((a, b) => a.order - b.order);
	const currentTab = tabs.find((t) => t.type == filterRef.current?.type);
	const onTabChange = (e, type) => {
		filterRef.current = { ...filterRef.current, type };
		trigger(filterRef.current);
	};

	// for the Asset Mapping and Scanning feature
	const [isAssetScan, setIsAssetScan] = useState(false);
	const [isAssetMap, setIsAssetMap] = useState(false);

	const canAssetAdd = assetAdd && currentChkPermission?.assetAdd?.value;
	const canAssetScan = assetScan && currentChkPermission?.assetScan?.value;

	const [startDate, setStartDate] = useState(null);
	const [openPrint, setOpenPrint] = useState(false);
	const [openCustomizeWorkflow, setOpenCustomizeWorkflow] = useState(false);

	// a ref to keep the vehicle entry ID
	const vehicleEntryIdRef = useRef("");

	// fetch data after applying filters
	const updateFilterAndTrigger = (filter) => {
		const type = tabs && tabs[0] && tabs[0].type;
		filterRef.current = { ...filter, checkpointId, type };
		trigger(filterRef.current);
		setIsForm(false);
		setIsDetail(false);
	};
	let filterFields = [
		{
			inputType: "searchDropdown",
			id: "1",
			name: "vehicleNumber",
			type: "text",
			label: "Vehicle No./ Trip Id",
			placeholder: "Enter search value",
			options: [
				{ label: "Vehicle Number", value: "vehicleNumber" },
				{ label: "Trip ID", value: "trip_counter" },
			],
			readOnly: false,
			error: "",
			value: "",
		},
		{
			inputType: "datePicker",
			id: "3",
			name: "start",
			label: "Start Date",
			maxDATE: dayjs(),
			readOnly: false,
			error: "",
			value: defaultStartDate,
		},
		{
			inputType: "datePicker",
			id: "4",
			name: "end",
			label: "End Date",
			minDATE: startDate ? dayjs(startDate) : null,
			maxDATE: dayjs(),
			readOnly: false,
			error: "",
			value: defaultEndDate,
		},
		{
			inputType: "dropdown",
			id: "3",
			name: "trip_status",
			label: "Trip Status",
			option: [
				{ label: "Ongoing", value: "Ongoing" },
				{ label: "Terminated", value: "Terminated" },
				{ label: "Cancelled", value: "Cancelled" },
				{ label: "Completed", value: "Completed" },
			],
		},
	];

	const handlePrint = () => {
		setOpenPrint(true);
		// console.log('calling print')
	};
	const handleCustomizeTripWokflow = () => {
		setOpenCustomizeWorkflow(true);
	};

	useEffect(() => {
		if (!checkpointId) return;
		updateFilterAndTrigger(filterRef.current);
	}, [checkpointId]);

	useEffect(() => {
		if (vehicleNumber) {
			const type = tabs && tabs[0] && tabs[0].type;
			const filterRef1 = { ...defaultFilter, searchBy: "vehicleNumber", search: vehicleNumber, checkpointId, type };
			trigger(filterRef1);
			setIsForm(false);
			setIsDetail(false);
		} else if (location.pathname) {
			updateFilterAndTrigger(defaultFilter);
			// console.log("location.pathname")
		} else {
			updateFilterAndTrigger(filterRef.current);
			// console.log("not found vehicle number")
		}
	}, [location.pathname, vehicleNumber, checkpointId]);
	const [handleCheckout] = useSaveCheckoutFormMutation();
	const [getDetail, { data, isFetching: isFetchingDetail }] = useLazyGetCheckpointEntryDetailQuery();
	let { data: detailData, tableHeader: detailTableHeaders, historicalDataHeaderMap } = data || { tableHeader: [] };
	// detailData = shouldRunTour || isTourMode ? dummyTourData[0] : detailData;
	const isHistoricalHeadersLoading = !historicalDataHeaderMap && isFetchingDetail;
	const [isDetail, setIsDetail] = useState(null);
	const handleDetailClose = () => {
		setIsDetail(false);
	};
	// IF SOCKET EVENT DOES NOT WORKS PROPERLY.... THEN IN THIS CASE CALLING GET-CHECKPOINT-DATALIST AND STATS AFTER EVERY 90 SECS
	const triggerWithCurrentFilters = useCallback(() => {
		if (filterRef.current && !isDetail) {
			trigger(filterRef.current);
		}
	}, [trigger, isDetail]);

	useEffect(() => {
		if (isDetail) return;
		const intervalId = setInterval(triggerWithCurrentFilters, 90000);
		return () => clearInterval(intervalId);
	}, [triggerWithCurrentFilters, isDetail]);
	const updateDataRef = useRef(null);

	const checkoutDataRef = useRef(null);

	const [isModal, setIsModal] = useState(false);
	const onModalClose = () => {
		setIsModal(false);
		if (updateDataRef.current) {
			updateDataRef.current = null;
		}
	};
	const onModalToggle = () => setIsModal(!isModal);

	const [isForm, setIsForm] = useState(false);
	const isRecallStats = !isDetail && !isForm && checkpointId;
	const onFormClose = () => {
		setIsForm(false);
		setIsCheckpointForm(false);
		if (updateDataRef.current) {
			updateDataRef.current = null;
		}
	};
	const onFormToggle = () => {
		setIsForm(!isForm);
		setIsCheckpointForm((o) => !o);
	};

	const onPageChange = (page_no) => {
		filterRef.current = { ...filterRef.current, page_no: page_no + 1 };
		trigger(filterRef.current);
	};
	const onPageSizeChange = (e) => {
		const { value } = e.target;
		filterRef.current = { ...filterRef.current, pagesize: value, page_no: 1 };
		trigger(filterRef.current);
	};

	const handleSpeech = (event, id) => {
		event.preventDefault();
	};

	const checkCheckpointData = (checkpointEvents, checkpointData) => {
		if (!checkpointData || !checkpointData.length) {
			return [...checkpointEvents];
		}

		if (Number(currentTab?.order) != 1) {
			return checkpointData;
		}

		let rangeCheckoutEvents = new Set();
		const uniqueElements = checkpointEvents.filter((event) => {
			if (event.SOCKET_EVENT_TYPE == "range-checkout") {
				rangeCheckoutEvents.add(event._id);
			} else {
				return !checkpointData.some((item) => item._id === event._id && item.plantId == plantId);
			}
			return true;
		});
		checkpointData = checkpointData.filter((trip) => !rangeCheckoutEvents.has(trip._id));
		const result = [...uniqueElements, ...checkpointData];
		return result;
	};

	let actionHandlers = {
		view: async (dataEntry) => {
			const { _id } = dataEntry;

			//harcoding for vehicle entry detail.
			const payload = { vehicleEntryId: _id };
			getDetail([detailApi, payload]);
			setIsDetail(true);
		},
		submit: async (dataEntry) => {
			checkoutDataRef.current = dataEntry;
			if (checkoutOnSubmit) {
				const payload = { checkout: true, checkpointNumber, vehicleId: dataEntry.vehicleId, plantId };
				const { data } = await handleCheckout([checkoutFormEndpoint, payload]);
				const { error, message } = data || {};

				if (data && error) {
					toastMessage(false, message);
				} else {
					toastMessage(true, message);
				}
			} else {
				onModalToggle();
			}
		},
	};
	const onUpdateSuccess = () => {
		getUserTableHeaders({ template_id: templateId });
		trigger(filterRef.current);
	};
	const updateTableColumn = async (selectedArray) => {
		const updateTableHeaderPayload = {
			template_id: templateId,
			selected_headers: selectedArray,
		};
		if (updateTableHeaderPayload) {
			const {
				data: { error, message },
			} = await updateTableHeader(updateTableHeaderPayload);
			if (error) {
				toastMessage(false, message);
			} else {
				toastMessage(true, message);
				onUpdateSuccess();
			}
		}
	};

	let header = ["S.No", ...(tableHeader || []).map((_) => _.label)];
	let sortheader = tableHeader?.filter((_) => _.isSortable).map((_) => _.label) || [];

	if (sendApproval) header.push("Approval Status");
	header.push("Action");

	const filteredCheckpointData = checkpointData?.length > 0 || checkpointEvents?.length > 0 ? checkCheckpointData(checkpointEvents, checkpointData) : [];

	// console.log("filtercheckpointData====>", filteredCheckpointData, checkpointEvents);

	let rows = (shouldRunTour || isTourMode ? dummyTourData : [...filteredCheckpointData]).map((data, index) => {
		let row = [tCell(index + 1)];
		// for showing the latest socket event bg color in table listing
		row.bgColor = data.bgColor;
		for (let item of tableHeader) {
			let value = findDeepValue(data, item.name.split(".")) || "-";
			if (value == "-") {
				value = findDeepValue(data.formData, item.name.split("."));
			}

			if (typeof value == "object") {
				value = JSON.stringify(value);
			} else {
				value = capitalizeCamelCase(value);
			}
			if (item.type == "icon") {
				value = dataIconMap[value] || value;
			}
			if (item.name === "vehicleNumber") {
				row.push(tCell(value, "", "pointer", handleSpeech, data._id));
			} else {
				row.push(tCell(item.type === "date" ? formatDate(value, item.format) : value));
			}
		}
		const formattedStatus = capitalizeCamelCase(removeSpecialChars(data.approvalStatus));
		const approvalStatus = (
			<span className={`status ${!data.hasOwnProperty("isApproved") ? "Yellow" : data.isApproved ? "green" : "red"}`} title={formattedStatus}>
				{formattedStatus}
			</span>
		);

		if (sendApproval) row.push(tCell(approvalStatus));
		let handlers = { ...actionHandlers };

		const submitBtn = (
			<div className="actionhandlers" style={{width:"130px"}}>
				<Button onClick={() => handlers.submit(data)} text={checkoutBtnLabel} style={{ ...buttonClasses.lynkitOrangeFill }} />
			</div>
		);
		let submittedText = "";
		if (filterRef.current?.type === "pending") {
			submittedText = "";
		} else {
			submittedText = tCell(<span className="status green">{entrySuccessText || "Submitted"}</span>);
		}

		let curr_chkpntList = data.statusHistory.filter((obj) => obj.checkpointId === checkpointId);
		let curr_chkpnt = curr_chkpntList[curr_chkpntList.length - 1];
		let atCheckpoint = "NO";

		if (curr_chkpnt?.checkpointId && !checkoutOnApproval && !currentTab?.hideSubmit && ["Completed", "Ongoing"].includes(data.trip_status)) {
			// console.log("curr_chkpnt", curr_chkpnt, checkoutOnApproval, currentTab?.hideSubmit);
			// Action button only if end
			if (curr_chkpnt.inTime && !curr_chkpnt.outTime) {
				atCheckpoint = "YES";
			} else {
				atCheckpoint = "SUBMITTED";
			}
		} else {
			// No action button.
			atCheckpoint = "NO";
		}

		const action = (
			<div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
				<div className="eyeIcon" onClick={() => handlers.view(data)}>
					<EyeIcon className="view_icon" />
				</div>
				<div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
					{atCheckpoint === "NO" ? (
						""
					) : atCheckpoint === "YES" ? (
						<>
							{submitBtn}
							{canAssetAdd ? (
								<Button
									text={"Map Assets"}
									style={{ ...buttonClasses.lynkitOrangeFill, width: "7rem" }}
									onClick={() => {
										setIsAssetMap(true);
										vehicleEntryIdRef.current = data;
									}}
								/>
							) : null}
							{canAssetScan ? (
								<Button
									text={"Scan Assets"}
									style={{ ...buttonClasses.lynkitOrangeFill }}
									onClick={() => {
										setIsAssetScan(true);
										vehicleEntryIdRef.current = data;
									}}
								/>
							) : null}
						</>
					) : (
						submittedText
					)}
				</div>
			</div>
		);

		row.push(action);

		return row;
	});

	const handleFilterChange = (filter) => {
		if (Object.keys(filter)?.length > 0) {
			let obj = {};
			if (filter?.vehicleNumber || filter?.trip_counter || (filter?.start && filter?.end) || filter?.trip_status) {
				if (Object.keys(filter).includes("vehicleNumber") || Object.keys(filter).includes("trip_counter")) {
					obj["searchBy"] = filter?.vehicleNumber ? "vehicleNumber" : "trip_counter";
					obj["search"] = filter?.vehicleNumber || filter?.trip_counter || "";
				} else {
					obj["searchBy"] = "";
					obj["search"] = "";
				}
				if (filter?.start && filter?.end) {
					// const newEndDate = dayjs(filter?.end).add(1, "day").toDate().toISOString();
					// obj = { ...obj, start: filter?.start, end: newEndDate };
					const newStartDate = dayjs(filter?.start).startOf("day").toDate().toISOString();
					const newEndDate = dayjs(filter?.end).endOf("day").toDate().toISOString();
					obj = { ...obj, start: newStartDate, end: newEndDate };
				}
				if (filter?.trip_status) {
					obj["trip_status"] = filter?.trip_status;
				} else {
					obj["trip_status"] = "";
				}
			}
			if (Object.keys(obj).length > 0) {
				filterRef.current = { ...filterRef.current, ...obj, page_no: 1 };
				trigger(filterRef.current);
			}
		}

		if (Object.keys(filter)?.length === 0) {
			filterRef.current = { ...filterRef.current, ...{ start: "", end: "", searchBy: "", search: "" }, page_no: 1 };
			trigger(filterRef.current);
		}
	};
	const onFilterSubmit = (form) => {
		filterRef.current = { ...filterRef.current, ...(form.data || {}) };
		// console.log(filterRef.current, form.data);
		trigger(filterRef.current);
		setShowFilters(false);
	};
	const onFilterChange_dynamic = useCallback(
		debounce((name, value) => {
			// console.log({ name, value });
			filterRef.current = { ...filterRef.current, [name]: value };
			trigger(filterRef.current);
		}, 500),
		[]
	);
	const addButton = currentChkPermission.manualEntry?.value ? <Button onClick={onFormToggle} text={isForm ? "Go Back" : "Add New"} style={{ ...buttonClasses.lynkitOrangeEmpty }} /> : null;

	const [redirecting, setRedirecting] = useState(false);

	if (isLoading || redirecting) return <Loader size="3rem" height="100%" />;
	if (
		(isCheckpointFetched && isInValidCheckpoint) ||
		(checkpointId && isFetched && userPermissions && Object.keys(userPermissions).length && !Object.keys(userPermissions).find((key) => key.includes(checkpointId)))
	) {
		if (!redirecting) {
			// when running locally, disable React Strict Mode for this to work correctly
			if (Array.isArray(checkpoints) && checkpoints[0]?.checkpointType && checkpoints[0]?.checkpointNumber) {
				toastMessage(false, "You do not have permission to access this checkpoint for the selected warehouse. You will be redirected to the first checkpoint that you have permnission for.", {
					onClose: () => {
						window.location.replace(`/checkpoints/${checkpoints[0].checkpointType}/${checkpoints[0].checkpointNumber}`);
					},
				});
			} else {
				toastMessage(false, "You do not have permission to access any checkpoint of this warehouse", {
					onClose: () => {
						window.history.back();
					},
				});
			}
			setRedirecting(true);
		}
	}
	const handleTourStart = () => {
		setIsTourMode(true);
		tourRef.current?.restartTour();
	};
	// console.log("Detailed data", detailData)
	return (
		<>
			<CommonTour
				ref={tourRef}
				steps={CheckpointTour}
				moduleName="checkpoint"
				onTourComplete={() => {
					setIsTourMode(false);
					// handleDetailClose();
				}}
			/>
			<div className="checkpoint-module">
				<Grid container spacing="1rem" className="checkpoint_panel" style={{ alignItems: "center" }}>
					<Grid item lg={11} md={10} sm={10} xs={8} className="checkpoint_heading">
						{displayName}
						{!isForm ? (
							<span title="Replay Tour" onClick={handleTourStart} style={{ cursor: "pointer" }}>
								<TourIcon />
							</span>
						) : null}
					</Grid>
					{currentChkPermission?.manualEntry ? (
						<Grid item lg={1} md={2} sm={2} xs={4}>
							{addButton}
						</Grid>
					) : null}
				</Grid>

				{isForm ? (
					<CheckpointForm open={isForm} onClose={onFormClose} updateData={updateDataRef.current} />
				) : (
					<>
						<div className="cust-row flex-algn-cent">
							<Genericstats checkpointID={checkpointId} filterType={filterRef.current?.type} isRecallStats={isRecallStats} isFactoryStats={checkpointType == "bay" && userPermissions?.factoryDashboard?.value === true ? true : false} />
						</div>
						{tabs?.length ? (
							<div className="checkpoint_tabs">
								<Tabs
									value={filterRef.current.type || tabs[0]?.type}
									onChange={onTabChange}
									sx={{
										"& .MuiTabs-indicator": { backgroundColor: theme.themeOrange },
										"& .MuiTab-root.Mui-selected": { color: theme.themeOrange },
									}}
								>
									{tabs?.map(({ label, type }, index) => {
										let _label = currentTab?.type == type && !isCheckpointDataLoading ? `${label} (${count || 0})`: label;
										return userPermissions[`checkpoint-${checkpointId}-${type}`]?.value ? <Tab value={type} label={_label} key={index} sx={{ ...textClasses.normalText, textTransform: "none", color: "var(--text-color)" }} /> : null;
									})}
								</Tabs>
								<div>
									<TableColumnCustomizer tableColumList={userTableHeaders} onApply={(selected) => updateTableColumn(selected)} />
								</div>
							</div>
						) : null}

						{templateDetail?.attributes?.length ? (
							<>
								<DynamicFormRender
									previewAttributes={primaryFilters}
									checkpointId={checkpointId}
									onFilterChange={onFilterChange_dynamic}
									filterOnly
									noBtn
									renderAction={(onClear) => {
										return (
											<div
												style={{
													display: "flex",
													gap: "1rem",
													alignItems: "center",
													// justifyContent: "center",
												}}
											>
												<Button onClick={onClear} text={"Clear All"} style={{ ...buttonClasses.lynkitOrangeEmpty, width: "fit-content" }} />
												<Button style={{ ...buttonClasses.lynkitOrangeFill, width: "fit-content" }} onClick={() => setShowFilters(true)}>
													<FilterListIcon /> Filter(s)
												</Button>
											</div>
										);
									}}
									plantId={plantId}
									plantName={plantName}
								/>

								<Drawer open={showFilters} onClose={() => setShowFilters(false)}>
									<div style={{ width: "35vw" }}>
										<div style={{ position: "relative", borderBottom: "1px solid var(--text-color)", padding: "1rem", display: "flex", alignItems: "center", gap: "0.75rem" }}>
											<CloseIcon sx={{ cursor: "pointer" }} onClick={() => setShowFilters(false)} />
											<span style={{ fontSize: "1.4rem" }}>Advance Filters</span>
										</div>
										<div style={{ width: "35vw", padding: "1rem" }}>
											<DynamicFormRender
												previewAttributes={secondaryFilters}
												checkpointId={checkpointId}
												filterOnly
												btn2Text="Apply"
												onSubmit={onFilterSubmit}
												noBtn
												renderAction={(onClear) => {
													return (
														<div
															style={{
																display: "flex",
																gap: "1rem",
																alignItems: "center",
																justifyContent: "center",
																marginTop: "1rem",
															}}
														>
															<Button onClick={onClear} text={"Clear All"} style={{ ...buttonClasses.lynkitOrangeEmpty, width: "fit-content" }} />
															<Button type="submit" text={"Apply"} style={{ ...buttonClasses.lynkitOrangeFill, width: "fit-content" }} />
														</div>
													);
												}}
												plantId={plantId}
												plantName={plantName}
											/>
										</div>
									</div>
								</Drawer>
							</>
						) : (
							<div className="cust-row flex-algn-cent">
								<Genericfilter addOnClear filterFields={filterFields} onFilterChange={debounce((filter) => handleFilterChange(filter), 500)} resetOnRouteChange />
							</div>
						)}

						<div className="main_content">
							<GenericTable
								sortheader={sortheader}
								header={header}
								rows={rows}
								pageCount={count}
								pageNo={page_no}
								limit={pagesize}
								onPageChange={onPageChange}
								onPageSizeChange={onPageSizeChange}
								isLoading={isCheckpointDataLoading}
								IsScroll={true}
							/>
						<div id="cpdetails">
							<div className={`detail_card ${isDetail ? "open" : ""}`}>
								{isDetail && (
									<Card sx={{ borderRadius: "12px", overflow: "hidden" }}>
										{isFetchingDetail || !historicalDataHeaderMap ? (
											// Show skeleton while loading
											<VehicleJourneyDetailSkeleton
												isOpen={isDetail}
												onClose={handleDetailClose}
												height="75vh"
											/>
										) : (
											// Show actual content when loaded
											<VehicleJourneyDetailCard
												isOpen={isDetail}
												onClose={handleDetailClose}
												data={detailData}
												tableHeader={detailTableHeaders}
												historicalDataHeaderMap={historicalDataHeaderMap}
												inTimeOutTimeConfig={checkoutConfigMap}
												handlePrint={handlePrint}
												customizeTripWorkflow={customizeTripWorkflow}
												handleCustomizeTripWorkflow={handleCustomizeTripWokflow}
												printLabelPerm={userPermissions?.printLabel?.value}
												height="75vh"
											/>
										)}
									</Card>
								)}
							</div>
							</div>
						</div>
					</>
				)}

				{openPrint ? (
					<PrintLabel
						open={openPrint}
						onClose={() => {
							setOpenPrint(false);
						}}
						checkpointId={checkpointId}
						detailData={detailData}
						detailTableHeaders={detailTableHeaders}
					/>
				) : null}
				{openCustomizeWorkflow ? (
					<CustomizeTripWorkflow
						open={openCustomizeWorkflow}
						onClose={() => {
							setOpenCustomizeWorkflow(false);
						}}
						detailData={detailData}
					/>
				) : null}
				{isModal ? <CheckpointFormPopup open={isModal} onClose={onModalClose} updateData={updateDataRef.current} checkoutData={checkoutDataRef.current} /> : null}
				{isAssetMap ? (
					<AssetAddForm
						open={isAssetMap}
						onClose={() => setIsAssetMap(false)}
						vehicleData={vehicleEntryIdRef.current}
						vehicleEntryId={vehicleEntryIdRef.current?._id}
						checkpointId={checkpointId}
					/>
				) : null}
				{isAssetScan ? (
					<AssetScanForm
						open={isAssetScan}
						onClose={() => setIsAssetScan(false)}
						vehicleData={vehicleEntryIdRef.current}
						vehicleEntryId={vehicleEntryIdRef.current?._id}
						checkpointId={checkpointId}
					/>
				) : null}
			</div>
		</>
	);
};

export default Checkpoint;

function CheckpointForm({ onClose, open, updateData }) {
	const { type, number } = useParams();
	const { checkpoints, isLoading } = useCheckpoints();
	const isInValidCheckpoint = !checkpoints.find((_) => _.checkpointType == type);
	const currentCheckpoint = checkpoints.find((_) => _.checkpointType == type && _.checkpointNumber == number) || {};
	const { plantId, plantName, plantCode } = usePlantContext();
	const { templateId, api: formEndpoint, checkpointNumber, _id: checkpointId, displayName: currentCheckpointName } = currentCheckpoint;

	const [handleSubmit, { isLoading: isSubmitting }] = useSaveCheckpointFormMutation();
	const { userDetail } = useUserDetail();
	const handleFormSubmit = async (data) => {
		let payload = { ...data, checkpointNumber, plantId, plantCode };
		checkForFlags(payload.data, currentCheckpointName, userDetail?.email);

		// console.log(payload);
		const {
			data: { error, message },
		} = await handleSubmit([formEndpoint, payload]);
		if (error) {
			toastMessage(false, message);
		} else {
			toastMessage(true, message);
			handleClose();
		}
	};
	const handleClose = () => {
		onClose();
	};

	if (isLoading) return <Loader size="3rem" height="100%" />;
	if (isInValidCheckpoint) return <Navigate to={REDIRECTION_URL} replace={true} />;

	return (
		<div style={{ marginTop: "1.5rem" }}>
			{/* <DynamicFormIFrame templateId={templateId} checkpointId={checkpointId} onClose={handleClose} onSubmit={handleFormSubmit} isSubmitDisabled={isSubmitting}/> */}
			<DynamicFormRender templateId={templateId} checkpointId={checkpointId} onClose={handleClose} onSubmit={handleFormSubmit} isSubmitDisabled={isSubmitting} plantId={plantId} plantName={plantName}/>
		</div>
	);
}

function CheckpointFormPopup({ onClose, open, updateData, checkoutData }) {
	const { type, number } = useParams();
	const { checkpoints, isLoading } = useCheckpoints();
	const isInValidCheckpoint = !checkpoints.find((_) => _.checkpointType == type);
	const currentCheckpoint = checkpoints.find((_) => (number ? _.checkpointType == type && _.checkpointNumber == number : _.checkpointType == type)) || {};
	const { checkpointNumber, checkoutConfig = {}, _id: checkpointId, displayName: currentCheckpointName } = currentCheckpoint;

	const { templateId: checkoutTemplateId, api, submitFormTitle = "Form Submit" } = checkoutConfig;
	const { userDetail } = useUserDetail();
	const { plantId, plantName, plantCode } = usePlantContext();

	const [handleCheckout, { isLoading: isSubmitting }] = useSaveCheckoutFormMutation();
	const handleFormSubmit = async (formData) => {
		let payload = { ...formData, checkpointNumber, plantId, plantCode };
		checkForFlags(payload.data, currentCheckpointName, userDetail?.email);

		const {
			data: { error, message },
		} = await handleCheckout([api, payload]);
		if (error) {
			toastMessage(false, message);
		} else {
			toastMessage(true, message);
			handleClose();
		}
	};

	const handleClose = () => {
		onClose();
	};
	if (isLoading) return <Loader size="3rem" height="100%" />;
	if (isInValidCheckpoint) return <Navigate to={REDIRECTION_URL} replace />;

	return (
		<Dialog size="lg" open={true} handleClose={onClose} title={submitFormTitle} noBtn>
			<DynamicFormRender
				templateId={checkoutTemplateId}
				checkpointId={checkpointId}
				checkoutData={checkoutData}
				isSaveDraft
				onSubmit={handleFormSubmit}
				extraClass="popup"
				btnText="Save Draft"
				isSubmitDisabled={isSubmitting}
				plantId={plantId}
				plantName={plantName}
			/>
		</Dialog>
	);
}

function useScanBtn(onScanOver) {
	const ref = useRef(null);
	const [scannedText, setScannedText] = useState("");

	const [isFocus, setIsFocus] = useState(false);
	useEffect(() => {
		if (!isFocus || !ref.current) return;

		const focusListener = (e) => {
			setIsFocus(false);
		};
		const focusInListener = (e) => {
			setIsFocus(true);
		};
		ref.current.addEventListener("focusout", focusListener);
		ref.current.addEventListener("focusin", focusInListener);

		return () => {
			ref.current?.removeEventListener("focusout", focusListener);
			ref.current?.removeEventListener("focusin", focusInListener);
		};
	}, [isFocus]);

	const hiddenInput = (
		<input
			type="text"
			style={{ opacity: 0, position: "absolute" }}
			ref={ref}
			onChange={(e) => {
				setScannedText(e.target.value);
			}}
			onKeyDown={(e) => {
				if (e.key == "Enter") {
					onScanOver(scannedText);
					setScannedText("");
				}
			}}
			value={scannedText}
		/>
	);
	const scannBtnUI = (
		<Grid container spacing={3} alignItems={"center"}>
			{hiddenInput}
			<Grid item xl={3} lg={3} md={3} sm={4} xs={12}>
				<Button
					text={"Click to Start Scanning"}
					onClick={() => {
						ref.current?.focus();
						setIsFocus(true);
					}}
					style={{ ...buttonClasses.lynkitBlackEmpty }}
				/>
			</Grid>
			<Grid item xl={2} lg={2} md={3} sm={4} xs={12}>
				Status : {isFocus ? <span style={{ color: "green" }}>Can Scan</span> : <span style={{ color: "red" }}>Cannot Scan</span>}
			</Grid>
		</Grid>
	);

	return { scannBtnUI };
}

function AssetAddForm({ open, onClose, vehicleData, vehicleEntryId, checkpointId }) {
	const {
		socketData: { assetScanData },
		setSocketData,
	} = useSocketContext();

	const [form, setForm] = useState({
		tags: [],
	});
	const { getTags, tagOptions } = useTags({ page_no: 1, pagesize: 100, status: "Allocated", allocationType: "!vehicle" });
	let tagValues = tagOptions?.filter((tagOp) => form.tags?.find((tag) => tag.value == tagOp.value));

	const { getTagsScan, scannedTags: scannedTagsFromServer, clearData } = useTagsForScan();

	useEffect(() => {
		if (!scannedTagsFromServer.length) return;
		setSocketData((o) => ({ ...o, assetScanData: [...scannedTagsFromServer, ...o.assetScanData] }));
	}, [scannedTagsFromServer]);

	const { scannBtnUI } = useScanBtn((scannedText) => {
		getTagsScan({ epc: scannedText }); // tid: scannedText
	});

	let payload = {
		checkpointId,
		vehicleEntryId,
		tags: [
			...assetScanData.map((data) => {
				return {
					displayName: data.displayName,
					epc: data.epc,
					tId: data.tId,
					assetName: data.allocationDetails?.assetName,
					assetId: data.allocationDetails?.assetId,
					type: "scanned",
				};
			}),
			...form.tags.map(({ data }) => {
				return {
					displayName: data.displayName,
					epc: data.epc,
					tId: data.tId,
					assetName: data.allocationDetails?.assetName,
					assetId: data.allocationDetails?.assetId,
					type: "selected",
				};
			}),
		],
	};
	const handleDropdownSearch = useCallback(
		debounce((value) => {
			getTags({ search: value });
		}, 500),
		[]
	);

	const handleClose = () => {
		onClose();
		setSocketData((o) => ({ ...o, assetScanData: [] }));
		clearData();
	};

	const [addAssetTag] = useAddAssetTagMutation();
	const handleSubmit = async () => {
		const {
			data: { error, message },
		} = await addAssetTag(payload);
		if (error) {
			toastMessage(false, message);
		} else {
			toastMessage(true, message);
			handleClose();
		}
	};

	const handleItemRemove = (i, op) => {
		if (op.type == "scanned") {
			setSocketData((o) => ({ ...o, assetScanData: o.assetScanData.filter((_, j) => j != i) }));
		} else if (op.type == "selected") {
			if (op.epc) {
				setForm((o) => ({ ...o, tags: o.tags.filter((_) => _.data?.epc != op.epc) }));
			} else if (op.tId) {
				setForm((o) => ({ ...o, tags: o.tags.filter((_) => _.data?.tId != op.tId) }));
			}
		}
	};
	return (
		<Dialog open={open} title={`Map Assets (Trip ID : ${vehicleData.trip_counter}, Vehicle Number : ${vehicleData.vehicleNumber})`} handleClose={handleClose} handleSubmit={handleSubmit} size="lg">
			<Grid container spacing={1} mb={2}>
				<Grid item xl={8} lg={8} md={8} sm={8} xs={12}>
					<Dropdown
						name="tags"
						label={"Tags"}
						options={tagOptions}
						value={tagValues}
						onChange={(ops, name) => {
							setForm((o) => ({ ...o, [name]: ops }));
						}}
						multiple
						onInputChange={({ target: { value } }) => {
							handleDropdownSearch(value);
						}}
						openOnFocus
					/>
				</Grid>
			</Grid>
			{scannBtnUI}

			<AssetTable assets={payload.tags} handleRemove={handleItemRemove} />
		</Dialog>
	);
}

function AssetScanForm({ open, onClose, vehicleData, vehicleEntryId, checkpointId }) {
	const { assetTags: assetTagsServer, isLoading } = useAssetTags({ vehicleEntryId });

	const {
		socketData: { assetScanData },
		setSocketData,
	} = useSocketContext();

	let list = [];
	if (!assetScanData.length && !assetTagsServer.length) {
		list = [];
	} else if (!assetScanData.length && assetTagsServer.length) {
		list = [...assetTagsServer];
	} else if (assetScanData.length && !assetTagsServer.length) {
		list = [...assetScanData];
	} else {
		for (let tag of assetTagsServer) {
			let scannedTag = assetScanData.find((_) => _.tId == tag.tId || _.epc == tag.epc);
			if (scannedTag) {
				list.unshift(scannedTag);
			} else {
				list.unshift(tag);
			}
		}
	}

	const { scannBtnUI } = useScanBtn((scannedText) => {
		let matchedTag = assetTagsServer.find((_) => _.epc == scannedText || _.tId == scannedText);
		if (matchedTag) {
			setSocketData((o) => ({
				...o,
				assetScanData: [
					{
						displayName: matchedTag.displayName,
						epc: matchedTag.epc,
						tId: matchedTag.tId,
						assetName: matchedTag.assetName,
						assetId: matchedTag.assetId,
						isScan: true,
						type: "scanned",
					},
					...o.assetScanData,
				],
			}));
		} else {
			console.error(`You have scanned an Invalid Tag : ${scannedText}`);
		}
	});
	const [updateAssetTag] = useUpdateAssetTagMutation();
	const handleSubmit = async () => {
		const payload = {
			checkpointId,
			updatedTids: assetScanData.filter((_) => _.isScan).map((_) => _.tId),
			updatedEpcs: assetScanData.filter((_) => _.isScan).map((_) => _.epc),
		};
		const {
			data: { error, message },
		} = await updateAssetTag(payload);
		if (error) {
			toastMessage(false, message);
		} else {
			toastMessage(true, message);
			onClose();
		}
	};
	return (
		<Dialog open={open} size="lg" title={`Scan Assets (Trip ID : ${vehicleData.trip_counter}`} handleClose={onClose} handleSubmit={handleSubmit}>
			{isLoading ? (
				<Loader size="3rem" height="100%" />
			) : (
				<>
					{scannBtnUI}
					<AssetTable assets={list} />
				</>
			)}
		</Dialog>
	);
}

function AssetTable({ assets, handleRemove }) {
	return (
		<TableContainer component={Paper} sx={{ marginTop: "1rem", maxHeight: "50vh", overflow: "auto" }}>
			<Table aria-label="simple table">
				<TableHead sx={{ backgroundColor: "var(--table-header-bg-color)" }}>
					<TableRow>
						<TableCell>Sno</TableCell>
						<TableCell align="center">Tag Name</TableCell>
						<TableCell align="center">TID</TableCell>
						<TableCell align="center">EPC</TableCell>
						{/* <TableCell align="center">Asset Name</TableCell> */}
						{/* <TableCell align="center">Asset ID</TableCell> */}
						<TableCell align="center">Scanned</TableCell>
						{handleRemove ? <TableCell align="center">Action</TableCell> : null}
					</TableRow>
				</TableHead>
				<TableBody sx={{ backgroundColor: "var(--table-body-bg-color)", color: "var(--text-color)" }}>
					{assets?.map((op, i) => {
						return (
							<TableRow
								key={i}
								sx={{
									"&:last-child td, &:last-child th": {
										border: 0,
									},
									backgroundColor: op.type == "scanned" ? "#18A558" : "",
								}}
							>
								<TableCell align="center">{i + 1}</TableCell>
								<TableCell align="center">{op.displayName}</TableCell>
								<TableCell align="center">{op.tId || "-"}</TableCell>
								<TableCell align="center">{op.epc || "-"}</TableCell>
								{/* <TableCell align="center">{op.assetName || "-"}</TableCell> */}
								{/* <TableCell align="center">{op.assetId || "-"}</TableCell> */}
								<TableCell align="center">{op.isScan ? "Done" : "Pending"}</TableCell>
								{handleRemove ? (
									<TableCell align="center">
										<CloseIcon style={{ fill: "var(--icon-color)", cursor: "pointer" }} onClick={() => handleRemove(i, op)} />
									</TableCell>
								) : null}
							</TableRow>
						);
					})}
				</TableBody>
			</Table>
		</TableContainer>
	);
}